export const iconPopAnimation = (e) => {
  const icon = e.currentTarget;
  icon.classList.add("animate-icon");
  setTimeout(() => {
    icon.classList.remove("animate-icon");
  }, 300);
};

export const iconPopAnimationSetting = (e) => {
  const icon = e.currentTarget;
  icon.classList.add("animate-icon");

  const timeoutId = setTimeout(() => {
    icon.classList.remove("animate-icon");
  }, 300);
  return () => clearTimeout(timeoutId);
};
